module.exports = __webpack_public_path__ + "static/logoWhite-95aeb2b1796519ea39d95ab582634663.png";